/**
 * Router de Fermin Admin (TanStack Router, rutas file-based en src/routes/).
 * No añadas rutas aquí: crea el archivo en src/routes/ y el plugin regenera routeTree.gen.ts.
 */
import { createRouter } from '@tanstack/react-router';

import { routeTree } from './routeTree.gen';

export const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  scrollRestoration: true,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
